import React from 'react';
import classNames from 'classnames';

type WrapperType = 'a' | 'div' | 'none';

interface CommonLinkWrapperProps extends React.HTMLAttributes<HTMLElement> {
  link?: string;
  wrapperType?: WrapperType;
  handleCustomClick?: () => void;
  disableLink?: boolean;
  openLinkInNewTab?: boolean;
  target?: React.HTMLAttributeAnchorTarget;
}

const CommonLinkWrapper = (props: CommonLinkWrapperProps) => {
  const {
    wrapperType = 'a',
    link = '',
    disableLink = false,
    handleCustomClick,
    openLinkInNewTab,
  } = props;

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    props.onClick?.(e);
    handleCustomClick?.();
  };

  const sharedProps = {
    ...props,
    onClick: handleClick,
    className: classNames(`tw-text-inherit`, props.className),
  };

  if (wrapperType === 'a' && link) {
    return (
      <a
        {...sharedProps}
        className={classNames(
          `tw-flex tw-cursor-pointer tw-no-underline`,
          sharedProps.className
        )}
        href={!disableLink ? link : undefined}
        target={props.target || (openLinkInNewTab ? '_blank' : undefined)}
      >
        {props.children}
      </a>
    );
  }

  if (wrapperType === 'div') {
    return <div {...sharedProps}>{props.children}</div>;
  }

  return <>{props.children}</>;
};

export default CommonLinkWrapper;
